import { Component, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Params } from "@angular/router";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { ModalController, ToastController } from "@ionic/angular";
import { InstallmentExtendModel } from "src/app/model/InstallmentTypeModel";
import { Page } from "src/app/model/Page";
import { PaymentSettlementService } from "src/app/services/payment-settlement.service";

@Component({
  selector: "payment-defaulter-view",
  templateUrl: "./payment-defaulter-view.component.html",
  styleUrls: ["./payment-defaulter-view.component.scss"],
})
export class PaymentDefaulterDtlComponent implements OnInit {
  approveForm: FormGroup = new FormGroup({});
  pan: string;
  applicantName: string;
  applicationNo: string;
  dateColorFormat: Date;
  polDate: string;
  page: Page<InstallmentExtendModel>;
  dataSource: MatTableDataSource<InstallmentExtendModel> =
    new MatTableDataSource();
  form: FormGroup = new FormGroup({});
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns: string[] = [
    "id",
    "installmentType",
    "oldInstallmentEndDate",
    "extensionDays",
    "paymentStatus",
  ];
  loaded: boolean = false;
  isSearchDisabled: boolean = false;

  pageSizeOptions: number[] = [10, 25, 100];

  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  constructor(
    private route: ActivatedRoute,
    private paymentSettlementService: PaymentSettlementService,

    private modalCtrl: ModalController,
    private toastController: ToastController
  ) {}

  ngOnInit(): void {
    this.loadInstallment();
  }
  loadInstallment() {
    this.route.params.subscribe((params: Params) => {
      this.paymentSettlementService
        .viewInstallmentType(this.applicationNo)
        .subscribe(
          (page: any) => {
            this.loaded = true;
            this.page = page;

            if (this.page.content[0].installmentType === "FIRST_INSTALLMENT") {
              this.polDate = this.page.content[0].polGeneratedDate;
            }
            // if (
            //   page.content.applicationNo !== null &&
            //   page.content.applicationNo !== ""
            // ) {
            if (page.content[0] !== null) {
              this.dataSource = new MatTableDataSource(page.content);
              this.loaded = false;
            } else {
              this.dataSource = new MatTableDataSource<InstallmentExtendModel>(
                []
              );
              this.loaded = false;
            }
            console.log("this.dataSource ", this.page);
            // } else {
            //   this.loaded = false;
            //   this.paymentSettlementService.errorToast(page.errorMessage);
            // }
            setTimeout(() => {
              this.paginator.pageIndex = this.currentPage;
              this.paginator.length = page.totalElements;
            });
            // this.isSearchDisabled = false;
          },
          (error) => {
            console.log(error);
            // this.isSearchDisabled = false;
          }
        );
      this.loaded = false;

      // .subscribe(async (page: any) => {
      //   console.log(" data ", page);
      //   // if (data.status === "SUCCESS") {
      //   this.page = page;
      //   this.dateColorFormat = page.content.oldInstallmentEndDate;
      //   // } else {
      //   //   this.paymentSettlementService.errorToast(data.errorMessage);
      //   // }
      //   let installmentFormList: FormArray = this.form.get(
      //     "installmentFormList"
      //   ) as FormArray;

      //   for (let k = 0; k < page.content.length; k++) {
      //     let installmentObj = page.content[k];

      //     let frmGrp = new FormGroup({
      //       key: new FormControl(installmentObj.key),
      //       installmentType: new FormControl(installmentObj.installmentType),
      //       oldInstallmentEndDate: new FormControl(
      //         installmentObj.oldInstallmentEndDate
      //       ),
      //       oldInstallmentEndDateNew: new FormControl(
      //         installmentObj.oldInstallmentEndDateNew
      //       ),
      //       extendDaysValue: new FormControl(installmentObj.extendDaysValue),
      //       paymentStatus: new FormControl(installmentObj.paymentStatus),
      //       instPaymentInterestRate: new FormControl(
      //         installmentObj.instPaymentInterestRate
      //       ),
      //       newInstPaymentInterestRate: new FormControl(
      //         installmentObj.newInstPaymentInterestRate
      //       ),
      //     });
      //     this.isDateLessThanToday(installmentObj.oldInstallmentEndDate);

      //     installmentFormList.push(frmGrp);
      //     // console.log("frmGrp", frmGrp.value);
      //   }

      //   // if (page.content[0] !== null) {
      //   //   this.dataSource = new MatTableDataSource(page.content);
      //   // } else {
      //   //   this.dataSource = new MatTableDataSource<InstallmentTypeModel>([]);
      //   // }
      // });
    });
  }
  isDateLessThanToday(date: string): boolean {
    // console.log(date, new Date(), new Date(date))
    // console.log(this.convertAndCompare(date));
    return new Date(date) <= new Date();
  }
  async showErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      message: errorMessage,
      icon: "information-circle",
      position: "top",
      duration: 2000,
    });
    toast.present();
  }

  async ngSubmit() {}
  handleKeyPress(event: KeyboardEvent): void {
    const textarea = event.target as HTMLTextAreaElement;
    const cursorPosition = textarea.selectionStart;
    if (cursorPosition === 0 && event.key === " ") {
      event.preventDefault();
    }
  }
  approve() {
    console.log("this.rejectForm", this.approveForm.value.approveReason);
    if (!this.approveForm.value.approveReason) {
      this.showErrorToast("Please Enter Approve Remark");
    }

    if (this.approveForm.valid) {
      return this.modalCtrl.dismiss(
        this.approveForm.value.approveReason,
        "approve"
      );
    }
  }

  cancel() {
    return this.modalCtrl.dismiss(null, "cancel");
  }
}
